module.exports = {"450921100":"容州镇","450921102":"杨梅镇","450921103":"灵山镇","450921104":"六王镇","450921105":"黎村镇","450921106":"杨村镇","450921107":"县底镇","450921108":"自良镇","450921109":"松山镇","450921110":"罗江镇","450921111":"石头镇","450921112":"石寨镇","450921113":"十里镇","450921114":"容西镇","450921115":"浪水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450921.json
// module id = 2136
// module chunks = 0